export class UpdateRackpositionRequest{
    selectedRows: any[];
    constructor(selectedRows: any[]){
        this.selectedRows = selectedRows;
    }
}